import React,{useState} from 'react';
import {useHistory} from 'react-router-dom';

const Signin = ({connection,setSuccessfulMessage}) => {

    const [User,setUser] = useState("");
    const [Email,setEmail] = useState("");
    const [Pass,setPass] = useState("");
    const [ConfirmPass,setConfirmPass] = useState("");
    const [wasSucceded,setWasSucceded] = useState(false);
    const [wasFailed,setWasFailed] = useState("");

    const history = useHistory();

    async function signIn(){

        if(Pass !== "" && ConfirmPass !== Pass){
            setWasFailed("As senhas não coincidem");
            return;
        }

        const result = await connection.post("/User/Add",
        {
            User:User,
            Password:Pass,
            Email:Email
        });

        setWasSucceded(setSuccessfulMessage(result.status));

        history.push('/Login');
    }

    function handleAddEmail(event){

        setEmail(event.target.value);

        
    }

    function handleAddUser(event){

        setUser(event.target.value);

        
    }

    function handleAddPass(event){

        setPass(event.target.value);

        
    }

    function handleConfirmPass(event){

        setConfirmPass(event.target.value);

    }

    return(
        <>
        <br/>
            {(function(){
                return (wasFailed !== "")? (
                    <div class="alert alert-danger" role="alert">
                         {wasFailed}
                    </div>
                ) : (<></>)
            })()}
            {(function(){
                return wasSucceded ? (
                <div class="alert alert-success" role="alert">
                    User successfuly created
                </div>) : (<></>)
                }
                )()}
            <center><h1>New Account</h1></center>

                <div class="mb-3">
                    <label htmlFor="InputUser" className="form-label">Username</label>
                    <input type="text" className="form-control" id="InputUser" aria-describedby="emailHelp" onKeyUp={handleAddUser}/>
                </div>
                <div class="mb-3">
                    <label htmlFor="InputEmail" className="form-label">Email address</label>
                    <input type="email" className="form-control" id="InputEmail" aria-describedby="emailHelp" onKeyUp={handleAddEmail}/>
                    <div id="emailHelp" className="form-text">We'll never share your email with anyone else.</div>
                </div>
                <div class="mb-3">
                    <label htmlFor="InputPassword" class="form-label">Password</label>
                    <input type="password" className="form-control" id="InputPassword" onKeyUp={handleAddPass}/>
                </div>
                <div class="mb-3">
                    <label htmlFor="InputPassword" class="form-label">Password</label>
                    <input type="password" className="form-control" id="InputPassword" onKeyUp={handleConfirmPass}/>
                </div>
                <button class="btn btn-primary" onClick={signIn}>Submit</button>
        </>
    )
};

export default Signin;